<template>
    <div class="PopupView" ref="rootView" :class="[{ show }, modes.map((m) => `PopupView--${m}`)]" :style="{ zIndex }"
        v-if="show">
        <div class="PopupViewContent" :style="{ width }">
            <slot name="title">
                <div class="PopupViewTitle">{{ title }}</div>
            </slot>
            <slot></slot>
            <div class="PopupViewClose" @click="onClose"><svg-view name="popup_close"></svg-view></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PopupView",
    props: {
        title: { type: String, default: '' },
        show: { type: Boolean, default: false },
        width: { type: String, default: '1000px' },
        zIndex: { type: Number, default: 101 },
        onClose: { type: Function, default: () => { } },
        modes: { type: Array, default: () => [] }
    },
    watch: {
        show(newValue, oldValue) {
            if (!oldValue && newValue) {
                $(this.$refs.rootView).scrollTop(0);
            }
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .PopupView;

@{r} {
    position: fixed;
    z-index: 101;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    padding: 100px 0;
    background: rgba(0, 0, 0, 0.3);
    visibility: hidden;

    &.show {
        visibility: visible;
    }

    &Content {
        background: white;
        margin: 0 auto;
        position: relative;
        overflow: hidden;
        box-shadow: 0px 20px 40px 0px rgba(0, 0, 0, 0.14);
        padding: 40px 40px 120px;
    }

    &Close {
        position: absolute;
        top: 0;
        right: 0;
        padding: 23px;
        cursor: pointer;

        svg {
            width: 24px;
            height: 24px;
            transition: fill 0.2s;
        }

        &:hover svg {
            fill: @color-link;
        }
    }

    &Title {
        font: @bold 30px/38px @Graphik-LCG;
        padding: 0 0 32px;
        letter-spacing: -0.05em;
        color: @color-black;
    }
}
</style>
